<div class="case-component gap-container" *ngIf="case">
  <section class="case-description">
    <app-case-description [case]="case"></app-case-description>
  </section>

  <section class="case-info">
    <app-case-information [case]="case"></app-case-information>
  </section>
</div>
